/**
 * Maps frontend automation schema to backend CreateTwitterAutomationInput
 * The frontend has quest properties at root level, backend expects them in questTemplate
 */
export function mapFrontendToBackend(frontendData, communityExternalAccountId) {
    return {
        name: frontendData.name,
        communityExternalAccountId,
        trigger: frontendData.trigger,
        questTemplate: {
            title: frontendData.title,
            description: frontendData.description,
            moduleId: frontendData.moduleId,
            taskType: frontendData.taskType,
            taskConfig: frontendData.taskConfig,
            rewards: frontendData.rewards,
            conditions: frontendData.conditions,
            conditionOperator: frontendData.conditionOperator,
            claimLimit: frontendData.claimLimit,
            retryAfter: frontendData.retryAfter,
            archiveAfterHours: frontendData.archiveAfterHours,
        },
        active: true,
    };
}
/**
 * Maps backend automation response to frontend automation schema
 * The backend has quest properties in questTemplate, frontend expects them at root level
 */
export function mapBackendToFrontend(backendData) {
    const questTemplate = backendData.questTemplate || {};
    return {
        id: backendData.id,
        active: backendData.active,
        name: backendData.name,
        trigger: backendData.trigger,
        // Flatten quest properties to root level
        title: questTemplate.title || '',
        description: questTemplate.description,
        moduleId: questTemplate.moduleId || '',
        taskType: questTemplate.taskType || 'tweetReact',
        taskConfig: questTemplate.taskConfig || {},
        rewards: questTemplate.rewards || [],
        conditions: questTemplate.conditions || [],
        conditionOperator: questTemplate.conditionOperator || 'AND',
        claimLimit: questTemplate.claimLimit || 0,
        retryAfter: questTemplate.retryAfter,
        archiveAfterHours: questTemplate.archiveAfterHours || 24,
        addToCurrentSprint: false, // Default value for frontend
        // Runtime metadata (these would come from aggregated data in a real implementation)
        questsCreated: 0,
        lastTriggered: undefined,
    };
}
